import React from "react";
import { Link } from "react-router-dom";
import Title from "../Title/Title";
import "./WellnessSpaces.css";

export default function Wellnesscats({ categories }) {
  return (
    <div>
      <Title title="Explore Our Essentials" />

      <div className="wellness-grid">
        {categories.map((cat, index) => {
          const slug = cat.slug || cat.name.toLowerCase().replace(/\s+/g, "-");

          return (
            <div
              key={index}
              className="wellness-card"
              style={{ backgroundImage: `url(${cat.image})` }}
            >
              <div className="wellness-overlay">
                <h3>{cat.name}</h3>

                <Link to={`/${slug}`} className="shop-btn">
                  Shop
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
